import { translate } from '../../../app/localisation';
import { selector } from './selector';

const HrTagsLoader = (function ($) {

    const ON_EACH_SIDE = 3;

    let state = {
        page: 1,
        perPage: 10,
        search: '',
        lastPage: 1,
        searchTimer: null,
        initialized: false,
    };

    function getUrl() {
        return $(selector.hrTagsConfig).data('url');
    }

    function fetchTags() {
        const url = getUrl();
        if (!url) return;

        $(selector.hrTagsLoading).show();
        $(selector.hrTagsList).html('');
        $(selector.hrTagsPagination).html('').hide();

        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'json',
            data: {
                page: state.page,
                perPage: state.perPage,
                search: state.search,
            },
        })
        .done(function (response) {
            const tags = response.tags?.items ?? [];
            const pagination = response.tags?.pagination ?? {};

            state.lastPage = pagination.last_page ?? 1;

            renderTags(tags);
            renderPagination(pagination);

            const consentChecked = $(selector.checkConsentHR).is(':checked');
            $(selector.tagsHR).prop('disabled', !consentChecked);
        })
        .fail(function () {
            $(selector.hrTagsList).html('<p class="text-danger small mt-2">' + translate('hr_tags_load_error') + '</p>');
        })
        .always(function () {
            $(selector.hrTagsLoading).hide();
        });
    }

    function renderTags(tags) {
        if (tags.length === 0) {
            $(selector.hrTagsList).html('<p class="text-muted small mt-2">' + translate('hr_tags_no_available') + '</p>');
            return;
        }

        const html = tags.map(function (tag, i) {
            const id = 'check_tag_' + state.page + '_' + i;
            const plate = tag.registrationPlate ? ' - ' + tag.registrationPlate : '';
            return '<div class="form-check py-1">'
                + '<input class="form-check-input js_tag_hr" type="checkbox" name="serial_number[]"'
                + ' value="' + tag.serialNumber + '" id="' + id + '" disabled>'
                + '<label class="form-check-label" for="' + id + '">'
                + tag.serialNumber + plate
                + '</label>'
                + '</div>';
        }).join('');

        $(selector.hrTagsList).html(html);
    }

    function range(from, to) {
        const arr = [];
        for (let i = from; i <= to; i++) arr.push(i);
        return arr;
    }

    function buildPageNumbers(current, last) {
        // All pages fit without ellipsis
        if (last < ON_EACH_SIDE * 2 + 6) {
            return range(1, last);
        }

        // Too close to beginning
        if (current <= ON_EACH_SIDE + 2) {
            return [...range(1, ON_EACH_SIDE + 2), '...', last - 1, last];
        }

        // Too close to end
        if (current >= last - ON_EACH_SIDE - 1) {
            return [1, 2, '...', ...range(last - ON_EACH_SIDE - 1, last)];
        }

        // Middle
        return [1, 2, '...', ...range(current - ON_EACH_SIDE, current + ON_EACH_SIDE), '...', last - 1, last];
    }

    function pageItem(page, label, active, disabled) {
        if (disabled) {
            return '<li class="page-item disabled"><span class="page-link">' + label + '</span></li>';
        }
        if (active) {
            return '<li class="page-item active" aria-current="page"><span class="page-link">' + label + '</span></li>';
        }
        return '<li class="page-item"><a class="page-link js_hr_page" href="#" data-page="' + page + '">' + label + '</a></li>';
    }

    function renderPagination(pagination) {
        const $pag = $(selector.hrTagsPagination);
        if (!pagination.last_page || pagination.last_page <= 1) {
            $pag.html('').hide();
            return;
        }

        const current = pagination.current_page;
        const last = pagination.last_page;
        const pages = buildPageNumbers(current, last);

        let items = '';

        items += pageItem(current - 1, '&#8249;', false, current <= 1);

        pages.forEach(function (p) {
            if (p === '...') {
                items += '<li class="page-item disabled"><span class="page-link">&hellip;</span></li>';
            } else {
                items += pageItem(p, p, p === current, false);
            }
        });

        items += pageItem(current + 1, '&#8250;', false, current >= last);

        $pag.html('<ul class="pagination pagination-sm mb-0">' + items + '</ul>').show();
    }

    function bindEvents() {
        $(document).on('input', selector.hrTagsSearch, function () {
            clearTimeout(state.searchTimer);
            const val = $(this).val();
            state.searchTimer = setTimeout(function () {
                state.search = val;
                state.page = 1;
                fetchTags();
            }, 700);
        });

        $(document).on('click', '.js_hr_page', function (e) {
            e.preventDefault();
            const page = parseInt($(this).data('page'), 10);
            if (page >= 1 && page <= state.lastPage) {
                state.page = page;
                fetchTags();
            }
        });
    }

    function init() {
        if (state.initialized) return;
        if ($(selector.hrTagsConfig).length === 0) return;
        state.initialized = true;
        bindEvents();
        fetchTags();
    }

    return { init: init };

})(jQuery);

export { HrTagsLoader };
